// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"_3dszz"};